import { render, staticRenderFns } from "./ViewDataForm.vue?vue&type=template&id=032aa672&"
import script from "./ViewDataForm.vue?vue&type=script&lang=js&"
export * from "./ViewDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports